import { createStylesMap } from 'app/theme/materialTheme';

export const styles = createStylesMap({
  button: (theme) => ({
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText,
  }),
});
